export default __webpack_public_path__ + "static/media/9.f4f3d50d.png";